import React from "react";

function Text() {
  return (
    <div className="divText">
      <h2>Try your luck!</h2>
      <p>
        Buy a ticket with <span id="e">0.01 </span> ether and take part in the
        raffle of the item you want!
      </p>
      <p>
        you can take part as many times as you want and increase your chances!
      </p>
    </div>
  );
}

export default Text;
